import './taskList.scss'
import { useLocal } from '@/i18n/LocalContext'
import { useCallback, useEffect, useRef, useState } from 'react'
import KowTitle from '../KowTitle/KowTitle'
import Prop from '../Prop/Prop'
import Receive from '../Receive/Receive'
import cloneDeep from 'lodash/cloneDeep'
import { rpx, throwError, toast } from '@/utils'
import { useStore } from '@/store'
import { checkPlayer } from '@/request/utils'
import { taskReceive } from '@/request'
import { clickReport } from '@/report'
import { randomCode } from '@base/lang'
import { Tooltip } from 'react-tooltip'

export default function TaskList() {
  const { $t } = useLocal()
  const { state, dispatch } = useStore()
  const tasks = state.tasks
  const friends = state.friends
  const playerId = state.login.userInfo.playerId
  const [list, setList] = useState<
    {
      type: 'share' | 'recall1' | 'recall2' | 'recall3' | 'integral'
      desc: string
      rewards: RewardViewList
      current: number
      reach: number
      total: number
      id?: number
      status: number
    }[]
  >([
    {
      type: 'share',
      desc: `${$t('每日首次分享活动')}(${$t('可完成5次，每日0点重置')})`,
      rewards: [
        {
          level: 3,
          name: '',
          icon: '',
          desc: '',
          count: 0,
        },
        {
          level: 3,
          name: '',
          icon: '',
          desc: '',
          count: 0,
        },
      ],
      status: 0,
      current: 0,
      reach: 0,
      total: 0,
    },
    {
      type: 'recall1',
      desc: $t('邀请1名领主回归'),
      rewards: [
        {
          level: 1,
          name: '',
          icon: '',
          desc: '',
          count: 0,
        },
        {
          level: 1,
          name: '',
          icon: '',
          desc: '',
          count: 0,
        },
      ],
      status: 0,
      current: 0,
      reach: 0,
      total: 0,
    },
    {
      type: 'recall2',
      desc: $t('邀请2名领主回归'),
      rewards: [
        {
          level: 2,
          name: '',
          icon: '',
          desc: '',
          count: 0,
        },
        {
          level: 2,
          name: '',
          icon: '',
          desc: '',
          count: 0,
        },
      ],
      status: 0,
      current: 0,
      reach: 0,
      total: 0,
    },
    {
      type: 'recall3',
      desc: $t('邀请3名领主回归'),
      rewards: [
        {
          level: 3,
          name: '',
          icon: '',
          desc: '',
          count: 0,
        },
        {
          level: 3,
          name: '',
          icon: '',
          desc: '',
          count: 0,
        },
      ],
      status: 0,
      current: 0,
      reach: 0,
      total: 0,
    },
    {
      type: 'integral',
      desc: $t('活动期间，被邀请领主在游戏内累计3000点获得日常任务积分'),
      rewards: [
        {
          level: 3,
          name: '',
          icon: '',
          desc: '',
          count: 0,
        },
        {
          level: 3,
          name: '',
          icon: '',
          desc: '',
          count: 0,
        },
      ],
      status: 0,
      current: 0,
      reach: 0,
      total: 0,
    },
  ])
  const [open, setOpen] = useState(false)
  const [propList, setPropList] = useState<typeof list[number]['rewards']>([])

  useEffect(() => {
    if (!tasks.length) return

    setList((oldList) => {
      const newList = cloneDeep(oldList)
      tasks.forEach((obj) => {
        const index = obj.id - 1
        const item = newList[index]
        item.status = obj.status
        item.rewards = obj.rewardViews
        item.current = obj.current
        item.reach = item.type === 'share' ? 1 : obj.total
        item.total = obj.total
        item.id = obj.id
      })
      return newList
    })
  }, [tasks])

  useEffect(() => {
    if (process.env.ENV === 'production') return

    if (window.queryObj.modal !== 'get') return

    if (list[0].rewards[0].count > 0) {
      setPropList(list[0].rewards)
      setOpen(true)
    }
  }, [list])

  const pending = useRef(false)
  const handleReceive = useCallback(
    async (item: typeof list[number], completed: boolean) => {
      if (!(await checkPlayer('task'))) return

      if (pending.current) return

      if (item.status === 2) {
        pending.current = true
        toast($t('您已完成该任务'))
        setTimeout(() => {
          if (item.type === 'share') {
            _triggerShare()
          }
          pending.current = false
        }, 1000)
        return
      }

      if (!completed) {
        switch (item.type) {
          case 'integral':
            try {
              const scroller = document.querySelector('.home')
              const app = document.getElementById('App')
              if (scroller && app) {
                const top = scroller.scrollHeight - app.clientHeight
                scroller.scrollTo({
                  top,
                  behavior: 'smooth',
                })
              }
            } catch (error) {
              throwError(error)
            }
            toast($t('绑定玩家完成日常任务获得积分'))
            break

          default:
            _triggerShare()
            break
        }
        return
      }

      pending.current = true
      let resReceive = await taskReceive(playerId, item.id)
      pending.current = false
      if (resReceive.items && resReceive.items.length > 0) {
        dispatch({
          type: 'play',
          data: resReceive.coupon,
        })
        setPropList(item.rewards)
        setOpen(true)
        let find = tasks.find((task) => task.id === item.id)
        find.status = 2
        dispatch({
          type: 'syncData',
          data: {
            friends,
            tasks,
          },
        })
      }

      function _triggerShare() {
        clickReport('share1')
        dispatch({
          type: 'updateModal',
          data: {
            shareOpen: true,
          },
        })
      }
    },
    [playerId, tasks, friends]
  )

  const onClose = useCallback(() => {
    setPropList([])
    setOpen(false)
  }, [])

  return (
    <div className="task-list-box">
      <KowTitle type="dark" text={$t('邀请任务')} />
      <ul className="task-list">
        {list.map((item, n) => {
          // const completed = item.current > 0 && item.current >= item.reach
          const completed = item.status == 1
          let statusText = $t('前往')
          // let status: 0 | 1 | 2 = 0
          let status = item.status
          if (status == 2) {
            statusText = $t('完成')
          } else if (status == 1) {
            statusText = $t('领取')
          }
          const descName = `t-desc-${randomCode(8)}-${n + 1}`
          return (
            <li key={n} className={`task task--${item.type}`}>
              <p className={`task__desc ${descName}`}>{item.desc}</p>
              <Tooltip
                anchorSelect={`.${descName}`}
                place="top"
                content={item.desc}
                style={{
                  zIndex: '4',
                  fontSize: rpx(24),
                  padding: rpx(10),
                  maxWidth: rpx(384),
                  background: 'rgba(0, 0, 0, 0.8)',
                }}
                positionStrategy="fixed"
                openEvents={{ click: true }}
              />
              {item.rewards.map((reward, i) =>
                !reward.icon ? null : (
                  <Prop
                    key={i}
                    level={reward.level}
                    name={reward.name}
                    imgSrc={reward.icon}
                    count={reward.count}
                    get={false}
                    desc={reward.desc}
                  />
                )
              )}
              <div className={`task-btn task-btn--${status}`}>
                <div className="task-btn__text-box">
                  <span className="task-btn__text">
                    {item.current} / {item.total}
                  </span>
                </div>
                <a
                  className="task-btn__status btn-active"
                  onClick={() => handleReceive(item, completed)}
                >
                  <span>{statusText}</span>
                </a>
              </div>
            </li>
          )
        })}
      </ul>
      <Receive
        open={open}
        text={$t(
          '领取成功，道具已通过邮件发送至您的角色。抽奖券需在活动时间内使用，请及时在页面使用。'
        )}
        propList={propList}
        onClose={onClose}
      />
    </div>
  )
}
